import { useMutation, gql } from '@apollo/react-hooks';
import { seeWorkOrderAsUser } from '#/graphql/mutations';
import type { SeeWorkOrderAsUserMutation } from '#/graphql/types';
import _ from 'lodash';
import { useCallback } from 'react';

const q = gql(seeWorkOrderAsUser);

const useWorkOrderSeeAsUser = () => {
  const [mutation, result] = useMutation<SeeWorkOrderAsUserMutation>(q);

  const seeWorkOrderAsUser = useCallback(
    async (workOrderId: string) => {
      const response = await mutation({ variables: { workOrderId } });

      return response.data?.seeWorkOrderAsUser?.data;
    },
    [mutation],
  );

  return { seeWorkOrderAsUser, result };
};

export default useWorkOrderSeeAsUser;
